<template lang="pug">
span.material-symbols-outlined.send-skip-guide(
  :class="{ active: value }"
  :title="title"
  role="switch"
  :aria-checked="String(!!value)"
  @click.stop="$emit('input', !value)"
) {{ value ? 'toggle_on' : 'toggle_off' }}
</template>

<script>
export default {
  name: 'SendSkipGuideToggle',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    title () {
      return this.value ? 'Enviar sin guía' : 'Requiere guía'
    }
  }
}
</script>

<style lang="stylus" scoped>
.send-skip-guide
  font-size 1.8rem
  line-height 1
  cursor pointer
  user-select none
  color rgba(0, 0, 0, .28)
  transition color .15s ease

.send-skip-guide:hover
  color rgba(0, 0, 0, .5)

.send-skip-guide.active
  color var(--color-font-principal, #363636)
</style>



// WEBPACK FOOTER //
// src/components/elements/order/SendSkipGuideToggle.vue